import { defineMessages } from "react-intl";
export default defineMessages({
    title: {
        id: "aiDiscoverability.communitySearch.title",
        defaultMessage: "Enter your community",
    },
    placeholder: {
        id: "aiDiscoverability.communitySearch.placeholder",
        defaultMessage: "Search for your community by name or address",
    },
    cantFind: {
        id: "aiDiscoverability.communitySearch.cantFind",
        defaultMessage: "Can't find your community?",
    },
    manuallyEnterDetails: {
        id: "aiDiscoverability.communitySearch.manuallyEnterDetails",
        defaultMessage: "Manually enter details",
    },
    noOptions: {
        id: "aiDiscoverability.communitySearch.noOptions",
        defaultMessage: "Search for a community",
    },
    noResults: {
        id: "aiDiscoverability.communitySearch.noResults",
        defaultMessage: "No communities found",
    },
    searchForCommunity: {
        id: "aiDiscoverability.communitySearch.searchForCommunity",
        defaultMessage: "Search for your community",
    },
    identifiedPropertySite: {
        id: "aiDiscoverability.communitySearch.identifiedPropertySite",
        defaultMessage: "Identified Property Site",
    },
    websitePlaceholder: {
        id: "aiDiscoverability.communitySearch.websitePlaceholder",
        defaultMessage: "https://www.example.com",
    },
    websiteInvalid: {
        id: "aiDiscoverability.communitySearch.websiteInvalid",
        defaultMessage: "Please enter a valid URL",
    },
    manualCommunityNameLabel: {
        id: "aiDiscoverability.communitySearch.manualCommunityNameLabel",
        defaultMessage: "Community Name",
    },
    manualCommunityNamePlaceholder: {
        id: "aiDiscoverability.communitySearch.manualCommunityNamePlaceholder",
        defaultMessage: "Community Name",
    },
    manualCommunityNameRequired: {
        id: "aiDiscoverability.communitySearch.manualCommunityNameRequired",
        defaultMessage: "Community name is required",
    },
    manualAddressLabel: {
        id: "aiDiscoverability.communitySearch.manualAddressLabel",
        defaultMessage: "Enter Address",
    },
    manualAddressPlaceholder: {
        id: "aiDiscoverability.communitySearch.manualAddressPlaceholder",
        defaultMessage: "Community Address",
    },
    manualAddressRequired: {
        id: "aiDiscoverability.communitySearch.manualAddressRequired",
        defaultMessage: "Community address is required",
    },
    manualWebsiteLabel: {
        id: "aiDiscoverability.communitySearch.manualWebsiteLabel",
        defaultMessage: "Enter Property Site",
    },
    manualWebsitePlaceholder: {
        id: "aiDiscoverability.communitySearch.manualWebsitePlaceholder",
        defaultMessage: "Community Website Address",
    },
    manualWebsiteRequired: {
        id: "aiDiscoverability.communitySearch.manualWebsiteRequired",
        defaultMessage: "Community website is required",
    },
    revertToSearch: {
        id: "aiDiscoverability.communitySearch.revertToSearch",
        defaultMessage: "Revert to",
    },
    searchAndSelect: {
        id: "aiDiscoverability.communitySearch.searchAndSelect",
        defaultMessage: "search and select",
    },
});
